<template>
	<div style="height: 100%;">
		<div v-if="showMain" style="height: 100%;width: 100vw;">
			<headerComponent></headerComponent>
			<div class="container" >
				<div class="left">
					<left-nav></left-nav>
				</div>
				<div class="right">
					<!--<router-view name="levelbar"></router-view>-->
					<router-view></router-view>
				</div>
			</div>
			<footerCom></footerCom>
		</div>
		<router-view name="login"></router-view>

	</div>
</template>

<script>
	import headerComponent from '@/views/layout/headerComponent'
	import leftNav from '@/views/layout/leftnav'
	import footerCom from '@/views/layout/footer'

	export default {
		components: {headerComponent, leftNav, footerCom},
		name: 'layout-main',
		computed: {
			showMain() {
				return this.$route.name !== 'login' && this.$route.name !== 'register'
			}
		}
	}
</script>

<style scoped>
	.container {
		min-width: 1200px;
		width: 1200px;
		margin: 0 auto;
		padding-top: 70px;
		overflow: hidden;
		min-height: 100%;
		margin-bottom:-70px;
	}

	.left {
		float: left;
		height: 100%;
	}

	.right {
		float: right;
		width: 1030px;
		height: 100%;
		padding-bottom:70px;
	}


</style>



// WEBPACK FOOTER //
// src/views/layout/layoutMain.vue